import { render, staticRenderFns } from "./ItemRontott.vue?vue&type=template&id=42a63dac&scoped=true&"
import script from "./ItemRontott.vue?vue&type=script&lang=js&"
export * from "./ItemRontott.vue?vue&type=script&lang=js&"
import style0 from "./ItemRontott.vue?vue&type=style&index=0&id=42a63dac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a63dac",
  null
  
)

export default component.exports